<template>
  <vis-inner-layout>
    <vis-loading size="md" v-if="loading" logo />
    <vis-error size="md" v-else-if="error" with-default logo :state="state" />
    <div
      v-else
      :class="{
        'ba-shadow-xl permission__content': !isAutoLogout
      }"
      class="ba-relative ba-z-100 ba-w-full ba-max-w-sm sm:ba-w-auto sm:ba-max-w-none ba-max-h-full ba-m-auto ba-px-2 sm:ba-px-0 ba-py-10 md:ba-p-10 ba-text-base"
    >
      <footer class="ba-mx-4 permission__form-footer">
        <h4
          v-if="isAutoLogout"
          class="ba-text-xl ba-font-semibold ba-text-center ba-w-full ba-my-5 ba-select-none ba-text-white"
        >Выходим из личного кабинета</h4>
        <h4
          v-else
          class="ba-text-xl ba-font-semibold ba-text-center ba-w-full ba-my-5 ba-select-none ba-text-white"
        >Вы действительно хотите выйти из всех приложений?</h4>
        <vis-loading size="md" v-if="isAutoLogout" />
        <form
          class="sm:ba-flex"
          :class="{'ba-invisible ba-absolute': isAutoLogout}"
          :action="logoutUrl"
          method="POST"
          enctype="application/x-www-form-urlencoded"
          ref="logoutForm"
        >
          <input type="hidden" name="state" :value="logoutState" />
          <button type="submit" class="ba-text-xl ba-rounded-full btn btn--login">Выйти</button>
          <button
            disabled
            type="button"
            class="sm:ba-flex-no-shrink sm:ba-w-48 sm:ba-ml-4 ba-text-xl ba-rounded-full btn btn--cancel"
          >Отмена</button>
        </form>
      </footer>
    </div>
  </vis-inner-layout>
</template>

<script>
import VisInnerLayout from "./vis-inner-layout";
import { logoutMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-page-logout",
  components: {
    VisInnerLayout
  },
  mixins: [logoutMixin]
};
</script>
